import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterData',
})
export class FilterDataPipe implements PipeTransform {
  transform(
    value: Array<any>,
    params: { param: string; key?: string | number },
  ): any[] {
    if (!params.param || !params.key) {
      return value;
    }
    return value
      .filter((el) => {
        return Number.isInteger(Number(el[params.param]))
          ? Boolean(Number(el[params.param]))
          : true;
      })
      .filter((el) => {
        return (
          el[params.param]
            .toString()
            .toLowerCase()
            .indexOf(params.key.toString().toLowerCase()) > -1
        );
      });
  }
}
